import React, { useState, useEffect, useRef } from 'react';
import './ConnectedQuizStudent.css';
import moment from 'moment-timezone';
import Header from '../Header/Header';
import { Modal } from "react-bootstrap";
import Spinner from '../Spinner/Spinner';
import loaderColors1 from '../Spinner/loaderColors1.gif';
import CQStudentQuizTaker from './CQStudentQuiz/CQStudentQuizTaker';
import ellipseSVGName from './CQStudentQuiz/images/CQ_ellipsis.svg';
import CQStudentQuizResult from './CQStudentQuiz/CQStudentQuizResult';
import { withAuth, handleResponse, handleJwtTokenForKeppMeLoggedIn } from "../../app/util/HOC";
export function ConnectedQuizStudent() {
    const userVO = JSON.parse(localStorage.getItem('userVO'));
    const isTAUser = localStorage.getItem('cqassistantFlag');
    const keepMeLogIn = localStorage.getItem('keepLoggedIn') ? "true" : "false";
    const authToken = userVO.apJwtAuthenticationToken ? userVO.apJwtAuthenticationToken : localStorage.getItem('apJwtAuthenticationToken');
    var getBookList = JSON.parse(localStorage.getItem("getBookList")).bookVOList, count = 0;
    getBookList.map((book) => { if (book.bookType === "ConnectedQuiz") { count = book.totalCredits; } });
    const cqStudErrorModalClosePopup = useRef(null);
    const cqStudErrorModalCloseNotExistPopup = useRef(null);
    const cqStudErrorModalCloseNoLongerPopup = useRef(null);
    const cqProfQuizConcPopUpPhoneInputConRef = useRef(null);
    const cqStudErrorModalCloseErrOccuredPopup = useRef(null);
    const currentDateTime = moment(new Date()).format("YYYY-MM-DD HH:mm");
    const [defaultSemId, setDefaultSemId] = useState();
    const [anonyIdEditMsgData, setAnonyIdEditMsgData] = useState();
    const [showConFormPopUp, setShowConFormPopUp] = useState(false);
    const [isStudQuizzesLoading, setIsStudQuizzesLoading] = useState(true);
    const [redeem, setRedeem] = useState(''); const [classId, setClassId] = useState();
    const [yourId, setYourId] = useState(); const [yourEditId, setYourEditId] = useState();
    const [semEnd, setSemEnd] = useState(false); const [error, setError] = useState(false);
    const [classList, setClassList] = useState([]); const [semList, setSemList] = useState([]);
    const [anonymous, setAnonymous] = useState(false); const [msgData, setMsgData] = useState();
    const [requiresId, setReqUiresId] = useState(false); const [usedCode, setUsedCode] = useState(false);
    const [invalidCode, setInvalidCode] = useState(false); const [notAnonymous, setNotAnonymous] = useState(false);
    const [idAnonymous, setIdAnonymous] = useState(false); const [idAnonymousEdit, setIdAnonymousEdit] = useState(false);
    const [remCreditCount, setremCreditCount] = useState(parseInt(count));

    const [QTitle, setQuizStartPop] = useState({
        title: "", due: "", timeLeft: "", completedFlag: "",
        quizEndDate: "", qpQuizInstanceURL: "", publishResultInstantly: "",
        releaseOption: "", completedDate: "", releaseDate: "", closeDate: ""
    });
    const [showQuiz, setShowQuiz] = useState(false);
    const [showQuizNotification, setShowQuizNotification] = useState(false);
    const [showQuizResult, setShowQuizResult] = useState(false);
    const [showQuizProps, setShowQuizProps] = useState(
        {
            studQuizName: '', studQuizId: '', studQuizInstanceId: '',
            studSemId: '', studSemName: '', studProfName: '',
            studAsstname: '', studClassName: '', studClassId: '',
            studQuizPublish: '', studQuizRelOpt: '', studQuizED: '',
            studQuizRD: '', studQuizAfterRD: '', studQuizCD: '',
            studQuizComD: ''
        }
    );
    const getSessionVO = () => {
        return {
            "appType": "web",
            "deviceMacId": "",
            "keepMeLoggedInFlag": keepMeLogIn,
            "deviceOS": localStorage.getItem('deviceOS'),
            "deviceType": localStorage.getItem('deviceType'),
            "browserName": localStorage.getItem('browserName'),
            "sessionAuthenticationToken": userVO.sessionAuthenticationToken
        }
    }
    useEffect(() => {
        if (showConFormPopUp) {
            cqProfQuizConcPopUpPhoneInputConRef.current.focus();
        }
    }, [showConFormPopUp]);
    const handleHideContactMe = () => {
        setShowConFormPopUp(false);
    }
    const handleHideuseCodePopup = () => {
        setUsedCode(false);
    }
    useEffect(() => {
        if (usedCode) {
            cqStudErrorModalClosePopup.current.focus();
        }
    }, [usedCode]);
    useEffect(() => {
        if (invalidCode) {
            cqStudErrorModalCloseNotExistPopup.current.focus();
        }
    }, [invalidCode]);
    useEffect(() => {
        if (semEnd) {
            cqStudErrorModalCloseNoLongerPopup.current.focus();
        }
    }, [semEnd]);
    useEffect(() => {
        if (error) {
            cqStudErrorModalCloseErrOccuredPopup.current.focus();
        }
    }, [error]);
    function fetchStudentSemList() {
        var reqData = {
            "userVO": {
                "userId": userVO.userId,
                "userRole": userVO.userRole,
                "schoolId": userVO.schoolId,
                "userRoleId": userVO.userRoleId,
                "keepMeLoggedInFlag": keepMeLogIn,
                "userActivityVO": {
                    "lastReadBookId": "",
                    "lastReadPageNum": "",
                    "lastReadChapterId": "",
                    "lastReadSectionId": "",
                    "lastReadParagraphId": "",
                    "lastViewedOutlineId": "",
                    "lastReadSubSectionId": "",
                    "schoolId": userVO.schoolId,
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "EReader",
                    "pageNavigatingTo": "Bookshelf",
                },
                "sessionVO": getSessionVO()
            },
            "cqSemesterVO": { "schoolId": userVO.schoolId }
        };
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(reqData),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
        };
        fetch(`${localStorage.getItem('qpAPI')}/quiz/api/getActiveSemesterForStudent`, requestOptions)
            .then(handleResponse)
            .then(response => response.json())
            .then(handleJwtTokenForKeppMeLoggedIn)
            .then(data => {
                if (data) {
                    if (data.cqSemesterVOList) {
                        var cqSemesterVOList = Array.isArray(data.cqSemesterVOList) ? data.cqSemesterVOList : [data.cqSemesterVOList];
                        if (cqSemesterVOList.length === 0) { setIsStudQuizzesLoading(false); }
                        setSemList(cqSemesterVOList);
                    }
                }
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    function fetchStudentCqDashboard(semId) {
        var reqData = {
            "userVO": {
                "userId": userVO.userId,
                "userRole": userVO.userRole,
                "schoolId": userVO.schoolId,
                "userRoleId": userVO.userRoleId,
                "keepMeLoggedInFlag": keepMeLogIn,
                "userActivityVO": {
                    "lastReadBookId": "",
                    "lastReadPageNum": "",
                    "lastReadChapterId": "",
                    "lastReadSectionId": "",
                    "lastReadParagraphId": "",
                    "lastViewedOutlineId": "",
                    "lastReadSubSectionId": "",
                    "schoolId": userVO.schoolId,
                    "lastViewedCQSemesterId": semId,
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "EReader",
                    "pageNavigatingTo": "Bookshelf",
                },
                "sessionVO": getSessionVO()
            },
            "cqSemesterVO": { "semesterId": semId }
        };
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(reqData),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
        };
        fetch(`${localStorage.getItem('qpAPI')}/quiz/api/getStudentCQDashboard`, requestOptions)
            .then(handleResponse)
            .then(response => response.json())
            .then(handleJwtTokenForKeppMeLoggedIn)
            .then(data => {
                if (data) {
                    if (data.cqClassVOList) {
                        var cqClassVOList = Array.isArray(data.cqClassVOList) ? data.cqClassVOList : [data.cqClassVOList];
                        cqClassVOList.map(cqClass => {
                            if (cqClass.classQuizVOList) {
                                cqClass.classQuizVOList = Array.isArray(cqClass.classQuizVOList) ? cqClass.classQuizVOList : [cqClass.classQuizVOList];
                            }
                            if (cqClass.cqClassAssistantVOList) {
                                cqClass.cqClassAssistantVOList = Array.isArray(cqClass.cqClassAssistantVOList) ? cqClass.cqClassAssistantVOList : [cqClass.cqClassAssistantVOList];
                                cqClass.cqClassAssistantVOList.sort((user1, user2) => (user1.ccUserRole).localeCompare(user2.ccUserRole));
                            }
                        });
                        if (Array.from(new Set(cqClassVOList.map(x => { return (x.semesterId) }))).length > 1) {
                            setDefaultSemId("-99");
                        } else {
                            var semId = Array.from(new Set(cqClassVOList.map(x => { return (x.semesterId) }))).join('').trim();
                            setDefaultSemId(semId);
                        }
                        setClassList(cqClassVOList);
                        setIsStudQuizzesLoading(false);
                    }
                }
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    useEffect(() => {
        if (isTAUser == "true") {
            document.title = "Classes Enrolled - Connected Quizzing | Casebook Connect | Aspen Publishing";
        } else {
            document.title = "Connected Quizzing | Casebook Connect | Aspen Publishing";
        }
        fetchStudentSemList();
    }, []);
    useEffect(() => {
        if (semList.length > 0) {
            fetchStudentCqDashboard();
        }
    }, [semList])
    function fetchRedeem(redeem) {
        var reqData = {
            "userVO": {
                "userId": userVO.userId,
                "userRole": userVO.userRole,
                "userRoleId": userVO.userRoleId,
                "userActivityVO": {
                    "lastReadBookId": "",
                    "lastReadPageNum": "",
                    "lastReadChapterId": "",
                    "lastReadSectionId": "",
                    "lastReadParagraphId": "",
                    "lastViewedOutlineId": "",
                    "lastReadSubSectionId": "",
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "EReader",
                    "pageNavigatingTo": "Bookshelf",
                },
                "sessionVO": getSessionVO()
            },
            "cqClassCode": redeem
        }
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(reqData),
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        };
        fetch(`${localStorage.getItem('ENV')}/manageCQ/getClassTypeByClassCode`, requestOptions)
            .then(response => response.json())
            .then(data => {
                if (data.status === "true") {
                    if (data.cqClassVO.cqClassType) {
                        var cqClassType = data.cqClassVO.cqClassType;
                        localStorage.setItem("cqClassType", cqClassType);
                        if (data.cqClassVO.cqClassType === "standard") {
                            redeemClassCode(redeem);
                        }
                        else {
                            setMsgData(data);
                            setIdAnonymous(true);
                        }
                    }
                    setInvalidCode(false)
                } else if (data.wkErrorCode) {
                    if (data.wkErrorCode === "bus.exception.class.code.has.been.already.used.by.you") {
                        setUsedCode(true);
                    } else if (data.wkErrorCode === "bus.exception.invalid.class.code") {
                        setInvalidCode(true);
                    }
                    else if (data.wkErrorCode === "bus.exception.semester.end.date.has.past.for.class.code") {
                        setSemEnd(true);
                    } else {
                        setError(true);
                    }
                }
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    function redeemClassCode(redeem) {
        var classType = localStorage.getItem("cqClassType");
        var reqData = {
            "userVO": {
                "userId": userVO.userId,
                "userRole": userVO.userRole,
                "userRoleId": userVO.userRoleId,
                "userActivityVO": {
                    "lastReadBookId": " ",
                    "lastReadPageNum": "",
                    "lastReadChapterId": "",
                    "lastReadSectionId": "",
                    "lastReadParagraphId": "",
                    "lastViewedOutlineId": "",
                    "lastReadSubSectionId": "",
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "EReader",
                    "pageNavigatingTo": "Bookshelf",
                },
                "sessionVO": getSessionVO()
            },
            "cqClassVO": { "cqClassCode": redeem, "cqClassType": classType }
        };
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(reqData),
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        };
        fetch(`${localStorage.getItem('ENV')}/manageCQ/redeemCQClassCode`, requestOptions)
            .then(response => response.json())
            .then(data => {
                if (data.status === "true") {
                    var redeemSemClassId;
                    if (data.cqProductVOList) {
                        data.cqProductVOList = Array.isArray(data.cqProductVOList) ? data.cqProductVOList : [data.cqProductVOList];
                    }
                    if (data.cqClassVO) { redeemSemClassId = data.cqClassVO.semesterId }
                    fetchStudentSemList(); fetchStudentCqDashboard(redeemSemClassId ? redeemSemClassId : '-99');
                    setremCreditCount(remCreditCount - 1); setMsgData(data);
                    setNotAnonymous(true); setRedeem('');
                } else if (data.wkErrorCode) {
                    if (data.wkErrorCode === "bus.exception.class.code.has.been.already.used.by.you") {
                        setUsedCode(true)
                    } else if (data.wkErrorCode === "bus.exception.invalid.class.code") {
                        setInvalidCode(true)
                    }
                    else if (data.wkErrorCode === "bus.exception.semester.end.date.has.past.for.class.code") {
                        setSemEnd(true)
                    } else {
                        setError(true)
                    }
                }
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    function redeemAnonymousclassCode(anonymousId) {
        var anonyId = anonymousId;
        var classType = localStorage.getItem("cqClassType");
        if (anonyId === "" || anonyId === undefined || anonyId === null) {
            setInvalidCode(true);
        }
        else {
            var reqData = {
                "userVO": {
                    "userId": userVO.userId,
                    "userRole": userVO.userRole,
                    "userRoleId": userVO.userRoleId,
                    "userActivityVO": {
                        "lastReadBookId": "",
                        "lastReadPageNum": "",
                        "lastReadChapterId": "",
                        "lastReadSectionId": "",
                        "lastReadParagraphId": "",
                        "lastViewedOutlineId": "",
                        "lastReadSubSectionId": "",
                        "lastActivityCode": "BOOKSHELF",
                        "pageNavigatingFrom": "EReader",
                        "pageNavigatingTo": "Bookshelf",
                    },
                    "sessionVO": getSessionVO()
                },
                "cqClassVO": {
                    "cqClassCode": redeem,
                    "cqAnonymousId": yourId,
                    "cqClassType": classType
                }
            };
            const requestOptions = {
                method: 'POST',
                body: JSON.stringify(reqData),
                headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            };
            fetch(`${localStorage.getItem('ENV')}/manageCQ/redeemCQClassCode`, requestOptions)
                .then(response => response.json())
                .then(data => {
                    if (data.status === "true") {
                        var redeemSemClassId;
                        if (data.cqProductVOList) {
                            data.cqProductVOList = Array.isArray(data.cqProductVOList) ? data.cqProductVOList : [data.cqProductVOList];
                        }
                        if (data.cqClassVO) { redeemSemClassId = data.cqClassVO.semesterId }
                        fetchStudentSemList(); fetchStudentCqDashboard(redeemSemClassId ? redeemSemClassId : '-99');
                        setremCreditCount(remCreditCount - 1); setMsgData(data);
                        setAnonymous(true); setRedeem(''); setYourId();
                    } else if (data.wkErrorCode) {
                        if (data.wkErrorCode === "bus.exception.class.code.has.been.already.used.by.you") {
                            setUsedCode(true)
                        } else if (data.wkErrorCode === "bus.exception.invalid.class.code") {
                            setInvalidCode(true)
                        }
                        else if (data.wkErrorCode === "bus.exception.semester.end.date.has.past.for.class.code") {
                            setSemEnd(true)
                        } else {
                            setError(true)
                        }
                    }
                }).catch(error => {
                    console.error("There has been a problem with your fetch operation:", error);
                });
        }
    }
    function updateUserAnonymousId(yourClassId, yourAnonyEditId) {
        if (yourAnonyEditId === "" || yourAnonyEditId === undefined || yourAnonyEditId === null) {
            setInvalidCode(true);
        }
        else {
            var reqData = {
                "userVO": {
                    "userId": userVO.userId,
                    "userRole": userVO.userRole,
                    "userRoleId": userVO.userRoleId,
                    "userActivityVO": {
                        "lastReadBookId": "",
                        "lastReadPageNum": "",
                        "lastReadChapterId": "",
                        "lastReadSectionId": "",
                        "lastReadParagraphId": "",
                        "lastViewedOutlineId": "",
                        "lastReadSubSectionId": "",
                        "lastActivityCode": "BOOKSHELF",
                        "pageNavigatingFrom": "EReader",
                        "pageNavigatingTo": "Bookshelf",
                    },
                    "sessionVO": getSessionVO()
                },
                "cqClassVO": { "cqClassId": yourClassId, "cqAnonymousId": yourAnonyEditId }
            };
            const requestOptions = {
                method: 'POST',
                body: JSON.stringify(reqData),
                headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            };
            fetch(`${localStorage.getItem('ENV')}/manageCQ/updateUserAnonymousId`, requestOptions)
                .then(response => response.json())
                .then(data => {
                    if (data.status === "true") {
                        setClassId();
                        setYourEditId();
                        fetchStudentCqDashboard(defaultSemId);
                    } else if (data.wkErrorCode) {
                        if (data.wkErrorCode === "bus.exception.class.code.has.been.already.used.by.you") {
                            setUsedCode(true);
                        } else if (data.wkErrorCode === "bus.exception.invalid.class.code") {
                            setInvalidCode(true);
                        }
                        else if (data.wkErrorCode === "bus.exception.semester.end.date.has.past.for.class.code") {
                            setSemEnd(true);
                        } else {
                            setError(true);
                        }
                    }
                }).catch(error => {
                    console.error("There has been a problem with your fetch operation:", error);
                });
        }
    }
    function postInstanceUrlToCC() {
        var reqData = {
            "userVO": {
                "userId": userVO.userId,
                "userRole": userVO.userRole,
                "schoolId": userVO.schoolId,
                "userRoleId": userVO.userRoleId,
                "keepMeLoggedInFlag": keepMeLogIn,
                "userActivityVO": {
                    "lastReadBookId": "",
                    "lastReadPageNum": "",
                    "lastReadChapterId": "",
                    "lastReadSectionId": "",
                    "lastReadParagraphId": "",
                    "lastViewedOutlineId": "",
                    "lastReadSubSectionId": "",
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "EReader",
                    "pageNavigatingTo": "Bookshelf",
                },
                "sessionVO": getSessionVO()
            },
            "classV": { "classId": showQuizProps.studClassId },
            "quizDetails": { "identifier": showQuizProps.studQuizId }
        };
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(reqData),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
        };
        fetch(`${localStorage.getItem('qpAPI')}/quiz/api/postUserQuizInstance`, requestOptions)
            .then(handleResponse)
            .then(response => response.json())
            .then(handleJwtTokenForKeppMeLoggedIn)
            .catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            })
    }
    useEffect(() => {
        if (semList.length > 0) {
            fetchStudentCqDashboard(defaultSemId)
        }
    }, [showQuiz]);
    function handleSetShowQuizProps(quiz) {
        var currDateTime = moment(new Date()).format("YYYY-MM-DD HH:mm");
        setQuizStartPop({
            title: quiz.name,
            due: (`Due: ` + (dateTimeModification(quiz.quizEndDate))),
            timeLeft: (
                convertTime(quiz.quizEndDate) > currDateTime ?
                    (createTimeLeft(quiz.quizEndDate, currDateTime).length > 0) ?
                        ('Time Left: ' + createTimeLeft(quiz.quizEndDate, currDateTime)) : ' '
                    : ' '
            ),
            completedFlag: quiz.completedFlag,
            quizEndDate: convertTime(quiz.quizEndDate),
            qpQuizInstanceURL: quiz.qpQuizInstanceURL,
            publishResultInstantly: quiz.publishResultInstantlyFlag,
            releaseOption: quiz.releaseOption,
            completedDate: ('Submitted: ' + dateTimeModificationEST(quiz.completedDate)),
            releaseDate: quiz.releaseDate,
            closeDate: quiz.closeDate
        })
    }
    function dateTimeModificationEST(beforeFormatDT) {
        var afterFDTZone = moment.tz.guess(),
            afterFDT = moment.utc(beforeFormatDT).clone().tz(afterFDTZone),
            afterFormatDT = moment(afterFDT).format('MMMM DD, YYYY - hh:mm A z');
        return afterFormatDT.replace('-', 'at');
    }
    function dateTimeModification(valchk) {
        var estTime = moment.tz(valchk, "America/New_York")
        var t = estTime.clone().tz(moment.tz.guess());
        var locTimeZon = estTime.clone().tz(moment.tz.guess()).format('z');
        var splittingTim = t.format().split("T");
        var timeCHk = splittingTim[1].split(":");
        t = dateModification(splittingTim[0]);
        if (timeCHk != undefined && timeCHk != null) {
            var meridian, hr, min;
            if (timeCHk[0] > 12) {
                meridian = "PM";
                hr = timeCHk[0] - 12;
                min = timeCHk[1];
            } else if (timeCHk[0] == "12") {
                meridian = "PM";
                hr = "12";
                min = timeCHk[1];
            } else {
                meridian = "AM";
                min = timeCHk[1];
                if (timeCHk[0] == "00") {
                    hr = "12";
                } else {
                    hr = timeCHk[0];
                }
            }
            t = '' + t + ' at ' + hr + ':' + min + ' ' + meridian + ' ' + locTimeZon;
        } else {
            t = '' + t + ' ';
        }
        return t;
    }
    function dateModification(archiveDate) {
        archiveDate = archiveDate.split(" ");
        var splitting = archiveDate[0].split("-");
        switch (splitting[1]) {
            case "01":
                splitting[1] = "January";
                break;
            case "02":
                splitting[1] = "February";
                break;
            case "03":
                splitting[1] = "March";
                break;
            case "04":
                splitting[1] = "April";
                break;
            case "05":
                splitting[1] = "May";
                break;
            case "06":
                splitting[1] = "June";
                break;
            case "07":
                splitting[1] = "July";
                break;
            case "08":
                splitting[1] = "August";
                break;
            case "09":
                splitting[1] = "September";
                break;
            case "10":
                splitting[1] = "October";
                break;
            case "11":
                splitting[1] = "November";
                break;
            case "12":
                splitting[1] = "December";
        }
        return splitting[1] + " " + splitting[2] + ", " + splitting[0];
    }
    function createTimeLeft(enddate, now) {
        var estTimes = moment.tz(enddate, "America/New_York")
        var t = estTimes.clone().tz(moment.tz.guess());
        var splittingTim = t.format().split("T");
        var quizDateAfterConv = moment(splittingTim, "YYYY-MM-DD HH:mm"),
            currDateAfterConv = moment(now, "YYYY-MM-DD HH:mm"),
            datesDiffInSecs = quizDateAfterConv.diff(currDateAfterConv, 'seconds');
        return convertSecondsToHMS(datesDiffInSecs);
    }
    function convertSecondsToHMS(value) {
        var diffInDays = parseInt(value / (24 * 3600));
        value = value % (24 * 3600); var diffInHrs = parseInt(value / 3600);
        value %= 3600; var diffInMins = value / 60;
        var days, hours, minutes, daysAftComma, hrsAftComma;
        days = (diffInDays > 0 ? ((diffInDays === 1 ? (diffInDays + " day") : (diffInDays + " days"))) : "");
        daysAftComma = (diffInDays > 0 ? ((diffInHrs > 0 || diffInMins > 0) ? ", " : "") : "");
        hours = (diffInHrs > 0 ? ((diffInHrs === 1 ? (diffInHrs + " hour") : (diffInHrs + " hours"))) : "");
        hrsAftComma = (diffInHrs > 0 ? (diffInMins > 0 ? ", " : "") : "");
        minutes = (diffInMins > 0 ? ((diffInMins === 1 ? (diffInMins + " minute") : (diffInMins + " minutes"))) : "");
        return (days + daysAftComma + hours + hrsAftComma + minutes);
    }
    function convertTime(valchk) {
        var estTime = moment.tz(valchk, "America/New_York")
        var t = estTime.clone().tz(moment.tz.guess());
        var splittingTim = t.format().split("T");
        var timeCHk = splittingTim[1].split(":");
        t = splittingTim[0];
        var time = timeCHk[0] + ":" + timeCHk[1]
        return t + " " + time;
    }
    function checkAnonymous() {
        if (yourId) {
            setReqUiresId(false)
            redeemAnonymousclassCode(yourId)
            setIdAnonymous(false)
            setYourId(false)
        } else {
            setReqUiresId(true)
            setIdAnonymous(true)
        }
    }
    function checkEditAnonymous() {
        if (yourEditId) {
            setReqUiresId(false)
            updateUserAnonymousId(classId, yourEditId)
            setIdAnonymousEdit(false)
        } else {
            setReqUiresId(true)
            setIdAnonymousEdit(true)
        }
    }
    function quizStart() {
        postInstanceUrlToCC();
        setShowQuiz(true);
    }
    function quizContinue() {
        setShowQuiz(true);
    }
    function handleAddKeypress(e) {
        var inputVal = e.target.value;
        if (e.key === 'Enter') {
            inputVal !== '' ? fetchRedeem(inputVal) : setInvalidCode(true);
        }
    }
    function handleEditIdKeypress(e) {
        if (e.key === 'Enter') {
            checkEditAnonymous();
        }
    }
    function handleIdKeypress(e) {
        if (e.key === 'Enter') {
            checkAnonymous();
        }
    }
    const foucsOnEnterClassCode = (event) => {
        event.preventDefault();
        var textbox = document.getElementById("cqStudInputCodeVal");
        if (textbox) {
            textbox.focus();
        }
    }

    useEffect(() => {
        let bookList = JSON.parse(localStorage.getItem('getBookList'));
        
        let bookVOList = bookList.bookVOList.map((bookVO, index) => { 
            if (bookVO.bookType === "ConnectedQuiz") { 
                bookVO.totalCredits = remCreditCount; 
            }
            return bookVO;
        });

        bookList.bookVOList = bookVOList
        localStorage.setItem('getBookList', JSON.stringify(bookList));
    }, [remCreditCount]);

    return (
        <>
            <Spinner
                loading={isStudQuizzesLoading}
                imageSrc={loaderColors1}
                overlayBackground="rgba(0,0,0,0.5)"
            />
            <div>
                <button onClick={foucsOnEnterClassCode} className="skip-to-main">Skip to the main</button>
                <Header userVO={userVO} pageName="CQStudent"></Header>
                {
                    showQuiz ?
                        <>
                            <div>
                                <div className="cqStudNotifiContainer">
                                    <div style={{ textAlign: "center" }} className="display-inline-block cqStudNotifiTxt col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        Connected Quizzing content is for personal use only. Redistribution is strictly prohibited. &copy; Aspen Publishing
                                    </div>
                                </div>
                            </div>
                            <CQStudentQuizTaker displayQuiz={() => setShowQuiz(false)} displayNotificationPopup={() => setShowQuizNotification(true)} data={showQuizProps} />
                        </>
                        : showQuizResult ?
                            <>
                                <div>
                                    <div className="cqStudNotifiContainer">
                                        <div style={{ textAlign: "center" }} className="display-inline-block cqStudNotifiTxt col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            Connected Quizzing content is for personal use only. Redistribution is strictly prohibited. &copy; Aspen Publishing
                                        </div>
                                    </div>
                                </div>
                                <CQStudentQuizResult displayQuizResult={() => setShowQuizResult(false)} data={showQuizProps} />
                            </>
                            :
                            <>
                                {
                                    isStudQuizzesLoading === false &&
                                    <main>
                                        <div className='container'>
                                            <div className="card cqStudContainerSection">
                                                <div className="card-body cqStudContainerCard">
                                                    <div className="row">
                                                        <div className="col-xl-7 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                            <div className="cqStudLogoContainer col-xl-7 col-lg-8 col-md-10 col-sm-12 col-xs-12">
                                                                <img className="cqStudLogo" src='/cc/images/CQ_logo_grey_screen.png' alt="Connected Quizzing" role='heading' aria-level='1'></img>
                                                            </div>
                                                            {
                                                                remCreditCount !== 0 ?
                                                                    <div className='col-lg-8 col-sm-12 col-xs-12'>
                                                                        <div className="cqStudViewContainer">
                                                                            <label htmlFor="cqStudInputCodeVal" className="cqStudCodeLabel">Enter a Class Code</label>
                                                                            <div className="input-group" >
                                                                                <input data-testid="input_class_code" id="cqStudInputCodeVal" type="text" className="form-control cqStudInputCode" aria-label="Enter a Class Code"
                                                                                    value={redeem} onKeyPress={(e) => handleAddKeypress(e)} onChange={(e) => setRedeem(e.target.value)} />
                                                                                <div className="input-group-append cqStudInputBtn">
                                                                                    <button className="input-group-text cqStudAddBtn" type='submit' aria-label="Add"
                                                                                        onClick={redeem !== '' ? () => fetchRedeem(redeem) : () => setInvalidCode(true)}>Add
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                            <p className="cqStudCredits">
                                                                                {remCreditCount} {remCreditCount === 1 ? 'Credit' : 'Credits'}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    :
                                                                    <div>
                                                                        <br /><br />
                                                                        <br /><br />
                                                                    </div>
                                                            }
                                                        </div>
                                                        {
                                                            classList.length !== 0 ?
                                                                <div className='col-xl-5 col-lg-6 col-md-6 col-sm-12 col-xs-12 mt-2'>
                                                                    <div className="cqProfViewContainer row">
                                                                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 cqProfViewingLabel text-sm-left text-md-right text-lg-right text-xl-right text-left pl-3" >
                                                                            <label htmlFor="selectedSemester">Viewing:</label>
                                                                        </div>
                                                                        <div className="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-9" style={{ paddingRight: '9px' }} >
                                                                            <select data-testid="select_semester" id="selectedSemester" aria-label="Selected Semester" className="cqProfViewingInput form-control text-box-common"
                                                                                value={defaultSemId} onChange={e => fetchStudentCqDashboard(e.target.value)}>
                                                                                {
                                                                                    semList.length <= 1 ? '' :
                                                                                        <option value="-99">All quizzes</option>
                                                                                }
                                                                                {
                                                                                    semList.map(sem => {
                                                                                        return (
                                                                                            <option key={sem.semesterId} value={sem.semesterId}>{sem.semesterName}</option>
                                                                                        )
                                                                                    })
                                                                                }
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                </div> : null
                                                        }
                                                    </div>
                                                    {
                                                        classList.length !== 0 ?
                                                            classList.map((studClass, indexStudClass) => (
                                                                <div className='cqStudClassDiv' key={indexStudClass}>
                                                                    <div className='cqStudQuizName mb-1' role="heading" aria-level="2">{studClass.cqTitle}</div>
                                                                    <p className='cqStudQuizProfNames mb-2' role="heading" aria-level="3">
                                                                        <span>{studClass.semesterName}</span> |
                                                                        <span> Professor {studClass.professorUserName}</span>
                                                                        {
                                                                            studClass.cqClassAssistantVOList ?
                                                                                <span>,
                                                                                    {
                                                                                        studClass.cqClassAssistantVOList.map((cqClassStud, index) => {
                                                                                            return (
                                                                                                <span key={index}>
                                                                                                    {cqClassStud.ccUserRole === 'Student' ? ` Assistant ` : ` Professor `}
                                                                                                    {cqClassStud.lastName}
                                                                                                    {index !== (studClass.cqClassAssistantVOList.length - 1) && ', '}
                                                                                                </span>
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                </span>
                                                                                : null
                                                                        } |
                                                                        <span> Class: {studClass.className}</span>
                                                                        {
                                                                            studClass.cqAnonymousId &&
                                                                            <>
                                                                                <span> | ID: {studClass.cqAnonymousId}</span>
                                                                                <img data-testid={`edit_id_${studClass.cqAnonymousId}`} className='cqStudAnonyId' onClick={() => [
                                                                                    setYourEditId(studClass.cqAnonymousId),
                                                                                    setClassId(studClass.classId),
                                                                                    setAnonyIdEditMsgData(studClass),
                                                                                    setIdAnonymousEdit(true)]} src={ellipseSVGName} alt='anonymous class elipse' />
                                                                            </>
                                                                        }
                                                                    </p>
                                                                    <div className='row pb-3 pl-2'>
                                                                        <ul className='m-0 p-0' style={{listStyleType: "none", width:"100%"}}> 
                                                                            {
                                                                                studClass.classQuizVOList === undefined ?
                                                                                    <div className='cqStudNoAssIext ml-2'>No Assignments</div>
                                                                                    : studClass.classQuizVOList
                                                                                        .map((quiz, index) => (
                                                                                            <li key={index} className='cqStudClassDiv col-xl-2 col-lg-2 col-md-3 col-sm-5 col-5 float-left'>
                                                                                                <div className='cqStudQuizBtnDiv'>
                                                                                                    <button className='btn cqStudQuizBtn'
                                                                                                        onClick={() => [handleSetShowQuizProps(quiz), setShowConFormPopUp(true),
                                                                                                        setShowQuizProps({
                                                                                                            studQuizName: quiz.name, studQuizId: quiz.identifier, studQuizInstanceId: quiz.instanceId,
                                                                                                            studSemId: studClass.semesterId, studSemName: studClass.semesterName, studProfName: studClass.professorUserName,
                                                                                                            studAsstname: studClass.cqClassAssistantVOList ? studClass.cqClassAssistantVOList : null, studClassName: studClass.className,
                                                                                                            studClassId: studClass.classId, studQuizPublish: quiz.publishResultInstantlyFlag, studQuizRelOpt: quiz.releaseOption,
                                                                                                            studQuizED: convertTime(quiz.quizEndDate), studQuizRD: convertTime(quiz.releaseDate), studQuizAfterRD: dateTimeModification(quiz.releaseDate),
                                                                                                            studQuizCD: convertTime(quiz.closeDate), studQuizComD: quiz.completedDate
                                                                                                        })]}
                                                                                                        data-toggle="modal" data-target="#cqQuizeModal00" type='button'
                                                                                                        style={
                                                                                                            quiz.completedFlag === true ?
                                                                                                                { background: '#DADADA', color: '#474747' }
                                                                                                                : quiz.qpQuizInstanceURL === undefined ?
                                                                                                                    convertTime(quiz.quizEndDate) > currentDateTime ?
                                                                                                                        { background: "#007AC3", color: "#FFFFFF" } :
                                                                                                                        { background: "#DADADA", color: "#474747" }
                                                                                                                    : convertTime(quiz.quizEndDate) > currentDateTime ?
                                                                                                                        { background: '#A6D1EB', color: '#474747' } :
                                                                                                                        { background: "#DADADA", color: "#474747" }
                                                                                                        }>{quiz.name}
                                                                                                    </button>
                                                                                                </div>
                                                                                                <div className='cqStudClassQuizDue pt-1'>
                                                                                                    {
                                                                                                        quiz.completedFlag === true ? 'Completed'
                                                                                                            : (convertTime(quiz.quizEndDate) > currentDateTime) ?
                                                                                                                (`Due: ` + dateTimeModification(quiz.quizEndDate)) : 'Not Submitted'
                                                                                                    }
                                                                                                </div>
                                                                                            </li>
                                                                                        ))
                                                                            }
                                                                        </ul>
                                                                    </div>
                                                                    <div className='cqStudQuizBorder'></div>
                                                                </div>
                                                            ))
                                                            :
                                                            <div className='cqStudNoClass mt-2'>
                                                                Redeem an access code to enroll in a class.
                                                            </div>
                                                    }
                                                </div>
                                            </div>
                                            <div>
                                                <Modal style={{ top: "33%" }} aria-labelledby="quiz-title-info" className="modal fade" show={showConFormPopUp} onHide={() => handleHideContactMe()} role="dialog" aria-hidden="false">
                                                    <div className="cqStudPopupContent" >
                                                        <Modal.Header >
                                                            <Modal.Title id="quiz-title-info" role="heading" aria-level="2" aria-label={QTitle.title + "Quiz Information"} style={{ paddingLeft: "49px" }} className='cqProfQuizConcPopUpHeader m-auto'>
                                                                {QTitle.title}
                                                            </Modal.Title>
                                                            <input data-testid="close_confirmation" type="button" onClick={handleHideContactMe} ref={cqProfQuizConcPopUpPhoneInputConRef} className="pull-right closeBtnCqStud mr-2" value="X" />
                                                        </Modal.Header>
                                                        <div className="modal-body p-0">
                                                            <div className="cqStudPopupDate">
                                                                <div style={{ marginBottom: '10px' }}>
                                                                    {QTitle.due}
                                                                </div>
                                                                {
                                                                    QTitle.completedFlag == true ?
                                                                        <div>
                                                                            {QTitle.completedDate}
                                                                        </div>
                                                                        :
                                                                        <div>
                                                                            {QTitle.timeLeft}
                                                                        </div>
                                                                }
                                                            </div>
                                                            <div className='text-center'>
                                                                {
                                                                    QTitle.completedFlag == false && QTitle.qpQuizInstanceURL && QTitle.quizEndDate > currentDateTime ?
                                                                        <button type="submit" className="cqStudPopupBtn" data-dismiss="modal" style={{ width: '92px' }}
                                                                            onClick={() => [quizContinue(), setShowConFormPopUp(false)]}>Continue
                                                                        </button>
                                                                        : !QTitle.completedFlag && QTitle.quizEndDate > currentDateTime ?
                                                                            <button type="submit" data-dismiss="modal" className="cqStudPopupBtn" style={{ width: '75px' }}
                                                                                onClick={() => [quizStart(), setShowConFormPopUp(false)]}>Start
                                                                            </button>
                                                                            : QTitle.completedFlag == true ?
                                                                                <div>
                                                                                    <button type="submit" data-dismiss="modal" className="cqStudPopupBtn" style={{ width: '127px' }}
                                                                                        onClick={() => [setShowQuizResult(true), setShowConFormPopUp(false)]}>View Results
                                                                                    </button>
                                                                                    {
                                                                                        QTitle.publishResultInstantly == false ?
                                                                                            QTitle.releaseOption === "quiz_end" ?
                                                                                                QTitle.quizEndDate > currentDateTime ?
                                                                                                    <>
                                                                                                        <p className='cqStudPopupResTxt pt-2 px-2'>
                                                                                                            Your detailed results will be available after the quiz end date.
                                                                                                        </p>
                                                                                                    </> : null
                                                                                                : QTitle.releaseOption === "date_range" ?
                                                                                                    convertTime(QTitle.releaseDate) > currentDateTime ?
                                                                                                        <>
                                                                                                            <p className='cqStudPopupResTxt pt-2 px-2'>
                                                                                                                Your detailed results will be available on {dateTimeModification(QTitle.releaseDate)}.
                                                                                                            </p>
                                                                                                        </> :
                                                                                                        convertTime(QTitle.closeDate) <= currentDateTime ?
                                                                                                            <>
                                                                                                                <p className='cqStudPopupResTxt pt-2 px-2'>
                                                                                                                    The timeframe to view your detailed results has been closed by your professor.
                                                                                                                </p>
                                                                                                            </> : null
                                                                                                    : null
                                                                                            : null
                                                                                    }
                                                                                </div>
                                                                                :
                                                                                <p className="cqStudPopupNotSub">
                                                                                    <b>Not Submitted</b>
                                                                                </p>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Modal>
                                                <Modal show={notAnonymous} aria-labelledby="successful-connected-quiz" centered
                                                    className="modal fade notAnonymousPopUp" role="dialog" aria-hidden="false">
                                                    <div className="cqStudClassPopUpBox">
                                                        <div className="modal-header">
                                                            <h4 id="successful-connected-quiz" className="modal-title cqStudClassPopUpTitle mt-3" aria-label="Successful Connected Quiz Class Code Redemption Information" >
                                                                You've successfully redeemed Connected Quizzing for {msgData ? msgData.cqClassVO.cqTitle : ''} with Professor {msgData ? (msgData.cqClassVO.professorFirstName + ' ' + msgData.cqClassVO.professorLastName) : ''}
                                                            </h4>
                                                        </div>
                                                        <div className="modal-body pb-0">
                                                            <div className="cqStudClassPopUpSupportTxt my-3">
                                                                <p>
                                                                    If this is not the class you wanted to redeem, please contact
                                                                    <a href=' https://support.aspenpublishing.com/hc/en-us/requests/new'
                                                                        target='_blank'> Customer Support</a>.
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="cqStudClassPopUpBtnDiv">
                                                            <button className="cqStudClassPopUpOkayBtn" onClick={() => setNotAnonymous(false)}>Okay</button>
                                                        </div>
                                                    </div>
                                                </Modal>
                                                <Modal show={idAnonymous} aria-labelledby="contained-modal-title-vcenter" centered
                                                    className="modal fade " role="dialog" aria-hidden="true">
                                                    <div className="cqStudAnanyClassPopUpBox">
                                                        <div className="modal-header">
                                                            <h5 className="modal-title cqStudClassPopUpTitle mt-2 px-4" >
                                                                Connected Quizzing for {msgData ? msgData.cqClassVO.cqTitle : ''} with Professor {msgData ? (msgData.cqClassVO.professorFirstName + ' ' + msgData.cqClassVO.professorLastName) : ''} requires your Anonymous ID.
                                                            </h5>
                                                        </div>
                                                        <div className="modal-body cqStudAnanyClassPopUpBody">
                                                            <div className="cqStudEnterId mx-4">
                                                                <label className='cqStudAnanyClassPopUpLabel'>Enter your ID</label>
                                                                <input data-testid="anonymous_id" type="text" className="cqStudAnanyClassPopUpInput" value={yourId}
                                                                    onKeyPress={(e) => handleIdKeypress(e)}
                                                                    onChange={(e) => [setYourId(e.target.value), setReqUiresId(false)]}>
                                                                </input>
                                                                {
                                                                    requiresId === true &&
                                                                    <p className='cqStudAnanyClassPopUpInputErr'>
                                                                        An ID is required to enroll in this class.
                                                                    </p>
                                                                }
                                                            </div>
                                                            <div className="cqStudClassPopUpSupportTxt mt-4">
                                                                <p>
                                                                    If this is not the class you wanted to redeem, please contact
                                                                    <a href='https://support.aspenpublishing.com/hc/en-us/requests/new'
                                                                        target='_blank'> Customer Support</a>.
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="cqStudAnanyClassPopUpBtnDiv">
                                                            <button className="cqStudClassPopUpOkayBtn" onClick={() => checkAnonymous()}>Next</button>
                                                        </div>
                                                    </div>
                                                </Modal>
                                                <Modal show={idAnonymousEdit} aria-labelledby="contained-modal-title-vcenter" centered
                                                    className="modal fade " role="dialog" aria-hidden="true">
                                                    <div className="cqStudAnanyClassPopUpBox">
                                                        <div className="modal-header">
                                                            <h5 className="modal-title cqStudClassPopUpTitle mt-2 px-4" >
                                                                Connected Quizzing for {anonyIdEditMsgData ? anonyIdEditMsgData.cqTitle : ''} with Professor {anonyIdEditMsgData ? anonyIdEditMsgData.professorUserName : ''} requires your Anonymous ID.
                                                            </h5>
                                                        </div>
                                                        <div className="modal-body cqStudAnanyClassPopUpBody">
                                                            <div className="cqStudEnterId mx-4">
                                                                <label className='cqStudAnanyClassPopUpLabel'>Enter your ID</label>
                                                                <input data-testid="edit_anonymous_id" type="text" className="cqStudAnanyClassPopUpInput" value={yourEditId}
                                                                    onKeyPress={(e) => handleEditIdKeypress(e)}
                                                                    onChange={(e) => [setYourEditId(e.target.value), setReqUiresId(false)]}>
                                                                </input>
                                                                {
                                                                    requiresId === true &&
                                                                    <p className='cqStudAnanyClassPopUpInputErr'>
                                                                        Your ID is required for this class.
                                                                    </p>
                                                                }
                                                            </div>
                                                            <div className="cqStudClassPopUpSupportTxt mt-4">
                                                                <p>
                                                                    If this is not the class you wanted to redeem, please contact
                                                                    <a href='https://support.aspenpublishing.com/hc/en-us/requests/new'
                                                                        target='_blank'> Customer Support</a>.
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="cqStudAnanyClassPopUpBtnDiv">
                                                            <button className="cqStudAnanyClassPopUpSaveBtn" onClick={() => checkEditAnonymous()}>Save Changes</button>
                                                        </div>
                                                    </div>
                                                </Modal>
                                                <Modal show={anonymous} aria-labelledby="successful-connected-quiz2" centered
                                                    className="modal fade" role="dialog" aria-hidden="false">
                                                    <div className="cqStudClassPopUpBox">
                                                        <div className="modal-header">
                                                            <h5 id="successful-connected-quiz2" className="modal-title cqStudClassPopUpTitle mt-3" aria-label="Successful Connected Quiz Class Code Redemption Information">
                                                                You've successfully redeemed Connected Quizzing for {msgData ? msgData.cqClassVO.cqTitle : ''} with Professor {msgData ? (msgData.cqClassVO.professorFirstName + ' ' + msgData.cqClassVO.professorLastName) : ''}
                                                            </h5>
                                                        </div>
                                                        <div className="modal-body pb-0">
                                                            <div className="cqStudClassPopUpSupportTxt my-3">
                                                                <p>
                                                                    If this is not the class you wanted to redeem, please contact
                                                                    <a href='https://support.aspenpublishing.com/hc/en-us/requests/new'
                                                                        target='_blank'> Customer Support</a>.
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="cqStudClassPopUpBtnDiv">
                                                            <button className="cqStudClassPopUpOkayBtn" onClick={() => setAnonymous(false)}>Okay</button>
                                                        </div>
                                                    </div>
                                                </Modal>
                                                <Modal show={usedCode} onHide={() => handleHideuseCodePopup()} aria-labelledby="contained-modal-title-vcenter" dialogClassName="main-modals"
                                                    contentClassName='cqStudErrorMoalContent' className="modal fade" role="dialog" aria-hidden="true">
                                                    <div className='cqStudErrorModalBorder' >
                                                        <input data-testid="close_used_code_modal" type="button" onClick={handleHideuseCodePopup} ref={cqStudErrorModalClosePopup} className="pull-right closeBtnCqStud" value="X" />
                                                        <p className='p-2 m-0 cqStudErrorModalTxt'>
                                                            You are already enrolled in this class. Please try a different class code.
                                                        </p>
                                                    </div>
                                                </Modal>
                                                <Modal show={invalidCode} onHide={() => setInvalidCode(false)} aria-labelledby="contained-modal-title-vcenter" dialogClassName="main-modals"
                                                    contentClassName='cqStudErrorMoalContent' className="modal fade" role="dialog" aria-hidden="true">
                                                    <div className='cqStudErrorModalBorder' >
                                                        <input data-testid="close_invalid_code_modal" type="button" onClick={() => setInvalidCode(false)} ref={cqStudErrorModalCloseNotExistPopup} className="pull-right closeBtnCqStud" value="X" />
                                                        <p className='p-2 m-0 cqStudErrorModalTxt'>The class code you entered does not exist. Please check the code and try again.</p>
                                                    </div>
                                                </Modal>
                                                <Modal show={semEnd} onHide={() => setSemEnd(false)} aria-labelledby="contained-modal-title-vcenter"
                                                    dialogClassName="main-modals" contentClassName='cqStudErrorMoalContent' className="modal fade" role="dialog" aria-hidden="true">
                                                    <div className='cqStudErrorModalBorder' >
                                                        <input data-testid="close_expired_code_modal" type="button" onClick={() => setSemEnd(false)} ref={cqStudErrorModalCloseNoLongerPopup} className="pull-right closeBtnCqStud" value="X" />
                                                        <p className='p-2 m-0 cqStudErrorModalTxt'> This class is no longer in session. Please try a different class code.</p>
                                                    </div>
                                                </Modal>
                                                <Modal show={error} onHide={() => setError(false)} aria-labelledby="contained-modal-title-vcenter"
                                                    dialogClassName="main-modals" contentClassName='cqStudErrorMoalContent' className="modal fade" role="dialog" aria-hidden="true">
                                                    <div className='cqStudErrorModalBorder' >
                                                        <input data-testid="close_error_code_modal" type="button" onClick={() => setError(false)} ref={cqStudErrorModalCloseErrOccuredPopup} className="pull-right closeBtnCqStud" value="X" />
                                                        <p className='p-2 m-0 cqStudErrorModalTxt'>
                                                            An error occurred. Please log in again.
                                                        </p>
                                                    </div>
                                                </Modal>
                                                <Modal show={showQuizNotification} size="sm" aria-labelledby="contained-modal-title-vcenter" centered className="modal fade" role="dialog" aria-hidden="true">
                                                    <div className="cqStudExpireQuizPopUpBox">
                                                        <div className="modal-body pb-0 pt-1">
                                                            <div className='row'>
                                                                <div className='col-9 pr-0'>
                                                                    <p className='h6 pl-1 pb-0'>Your quiz session has expired due to inactivity and your responses have been saved.</p>
                                                                </div>
                                                                <div className='col-3 p-0 text-center'>
                                                                    <button className='cqStudClassPopUpOkayBtn w-auto px-4 mt-1' onClick={() => setShowQuizNotification(false)}>Ok</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Modal>
                                            </div>
                                        </div>
                                    </main>
                                }
                            </>
                }
            </div>
        </>
    )
}
export default withAuth(ConnectedQuizStudent);